module.exports = __webpack_public_path__ + "static/media/stories.88a74f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/menu/stories.jpg
// module id = 151
// module chunks = 0